import "core-js/modules/web.dom-collections.iterator.js";
/* eslint-disable import/no-cycle */
import React, { useState, useMemo, useCallback, useEffect } from "react";
import CloseIcon from "@pixel/assets/icons/Close";
import Box from "../Box";
// import Drawer from "../Drawer";
import IconButton from "../IconButton";
import Typography from "../Typography";
// import Divider from "../Divider";
// import ErrorBoundary from "../ErrorBoundary";
// import { styled, PixelTheme } from "../styles";
import ListSearchFilter from "../ListSearchFilter";
import ListSearchFilterButtons from "./ListSearchFilterButtons";
import { styled } from "../styles";
export const Header = styled("div")(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2, 2),
    boxShadow: '0px 4px 8px -1px rgb(0 0 0 / 5%)',
    borderBottom: "solid 1px ".concat(theme.palette.pixelContrast.fades.softer)
  };
});
export const Footer = styled("div")(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    padding: theme.spacing(2, 2),
    boxShadow: '0px -4px 8px -1px rgb(0 0 0 / 5%);',
    borderTop: "solid 1px ".concat(theme.palette.pixelContrast.fades.softer)
  };
});
const generateHashForFilterLookup = appliedSearchFilters => {
  let appliedSearchFilterHash = {};
  appliedSearchFilters.forEach(appliedSearchFilter => {
    appliedSearchFilterHash[appliedSearchFilter.searchFilterId] = appliedSearchFilter;
  });
  return appliedSearchFilterHash;
};
const ListSearchFiltersForwardRef = /*#__PURE__*/React.forwardRef((_ref4, _ref) => {
  let {
    searchFilters,
    appliedSearchFilters,
    onSearchFilterApplied,
    onClose = null,
    labelFilters = "Filters",
    labelApplyFilters = "Apply Filters",
    labelClearAllFilters = "Clear All",
    labelClose = "Close",
    labelClear = "Clear"
  } = _ref4;
  const [temporaryAppliedSearchFiltersHash, setTemporaryAppliedSearchFiltersHash] = useState(generateHashForFilterLookup(appliedSearchFilters));
  const [appliedSearchFilterCount, setAppliedSearchFilterCount] = useState(0);
  useEffect(() => {
    setTemporaryAppliedSearchFiltersHash(generateHashForFilterLookup(appliedSearchFilters));
    setAppliedSearchFilterCount(0);
  }, [appliedSearchFilters]);
  const handleChangeAppliedFilter = useCallback((searchFilter, appliedSearchFilter) => {
    const newAppliedFiltersHash = {
      ...temporaryAppliedSearchFiltersHash
    };
    newAppliedFiltersHash[searchFilter.id] = appliedSearchFilter;
    setTemporaryAppliedSearchFiltersHash(newAppliedFiltersHash);
    setAppliedSearchFilterCount(appliedSearchFilterCount + 1);
    return true;
  }, [appliedSearchFilterCount, temporaryAppliedSearchFiltersHash]);
  const handleClose = () => {
    if (onClose) {
      onClose(null);
    }
  };
  const onClearFilters = () => {
    setTemporaryAppliedSearchFiltersHash({});
    setAppliedSearchFilterCount(appliedSearchFilterCount + 1);
    onSearchFilterApplied([]);
  };
  const onAppliedNewSearchFilter = () => {
    const appliedFilterArray = Object.values(temporaryAppliedSearchFiltersHash).filter(appliedFilter => appliedFilter !== null);
    onSearchFilterApplied(appliedFilterArray);
  };
  const renderSearchFilters = useMemo(() => {
    return searchFilters === null || searchFilters === void 0 ? void 0 : searchFilters.map((searchFilter, i) => {
      const appliedFilterForSearchFilter = temporaryAppliedSearchFiltersHash[searchFilter.id];
      return /*#__PURE__*/React.createElement(ListSearchFilter, {
        key: searchFilter.id,
        searchFilter: searchFilter,
        appliedSearchFilter: appliedFilterForSearchFilter,
        onChangeAppliedFilter: handleChangeAppliedFilter,
        labelClear: labelClear
      });
    });
  }, [searchFilters, appliedSearchFilterCount,
  //because we cant use tempNewAppliedSearchFilters its too deep
  handleChangeAppliedFilter, temporaryAppliedSearchFiltersHash]);
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      height: "100%",
      width: 400
    },
    "data-testid": "ListSearchFitlers_Base"
  }, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      flex: 1
    },
    variant: "h3"
  }, labelFilters, " "), typeof onClose == "function" && /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(CloseIcon, null))), /*#__PURE__*/React.createElement(Box, {
    sx: {
      flex: 1,
      overflow: "scroll",
      pb: 10
    }
  }, renderSearchFilters), /*#__PURE__*/React.createElement(Footer, null, /*#__PURE__*/React.createElement(ListSearchFilterButtons, {
    onClearFilters: onClearFilters,
    onAppliedNewSearchFilter: onAppliedNewSearchFilter,
    applyEnabled: appliedSearchFilterCount > 0,
    onClose: onClose,
    labelClear: labelClear,
    labelApplyFilters: labelApplyFilters,
    labelClearAllFilters: labelClearAllFilters,
    labelClose: labelClose
  })));
});
export default ListSearchFiltersForwardRef;